import {Formik} from 'formik'
import {useDispatch, useSelector} from 'react-redux'
import CustomSelect from '../../core/customSelect'
import Input from '../../core/input'
import {handleFormChanges} from '../../../utils/forms'
import {SimpleBlueButton} from '../../core/button'
import {useEffect} from 'react'
import {addLogGroup, getLogGroup, updateLogGroup} from '../../../stores/log-management'
import Checkbox from '../../core/checkbox'
import Textarea from '../../core/textarea'
import {trimStringValues} from '../../../utils/text'
import {addLogGroupSchema} from '../../../utils/validation'
import ButtonLoader from '../../core/button/ButtonLoader'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const names = {
    name: 'name',
    service_id: 'service_id',
    team_id: 'team_id',
    retention: 'retention',
    description: 'description',
    enabled: 'enabled'
}
const DEFAULT_RETENTION_DAY = '30'

const AddEditLogGroup = ({logGroupId, onCloseModal}) => {
    const text = useNamespaceTranslations('log-management')
    const services = useSelector((state) => state.resources.services)
    const {logGroup, isButtonLoading} = useSelector((state) => state.log_management)
    const dispatch = useDispatch()

    const initialFormValues = {
        name: logGroupId ? logGroup?.name : '',
        description: logGroupId ? logGroup?.description : '',
        retention: logGroupId ? logGroup?.retention : DEFAULT_RETENTION_DAY,
        service_id: logGroupId ? services?.find((item) => item?.value === logGroup?.service_id) : services?.[0] || '',
        enabled: logGroupId ? !!logGroup?.enabled : true
    }

    const handleChangeFormValue = (value, name, setFieldValue, initialFormValues, isCheckbox = false) => {
        handleFormChanges(
            value,
            name,
            setFieldValue,
            initialFormValues,
            isCheckbox
        )
    }

    const addEditLogGroup = async(values, {setFieldError}) => {
        const payload = trimStringValues({...values, service_id: values.service_id.value, retention: Number(values.retention)})
        const success = !logGroupId ? await dispatch(addLogGroup(payload, setFieldError)) :
            await dispatch(updateLogGroup(logGroupId, payload, setFieldError))
        success && onCloseModal()
    }

    useEffect(() => {
        if (logGroupId) {
            dispatch(getLogGroup(logGroupId, false))
        }
    }, [logGroupId])

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialFormValues}
            onSubmit={addEditLogGroup}
            validationSchema={addLogGroupSchema}
            validateOnBlur={false}
            validateOnChange={false}
        >
            {({values, errors, handleSubmit, setFieldValue}) => (
                <form onSubmit={handleSubmit} className="modal-body">
                    <Input
                        type="text"
                        value={values[names.name]}
                        onChange={(e) => handleChangeFormValue(
                            e,
                            names.name,
                            setFieldValue,
                            initialFormValues
                        )}
                        placeholder={text.name}
                        name={names.name}
                        error={errors?.name}
                        infoText={text.name_info}
                    />
                    <Textarea
                        name={names.description}
                        value={values.description}
                        error={errors?.description}
                        onChange={(e) => handleChangeFormValue(
                            e,
                            names.description,
                            setFieldValue,
                            initialFormValues
                        )}
                        placeholder={text.description}
                        infoText={text.description_info}
                    />
                    <Input
                        type="number"
                        value={values.retention}
                        placeholder={text.retention}
                        error={errors?.retention}
                        infoText={text.retention_info}
                        onChange={(e) => handleChangeFormValue(
                            e,
                            names.retention,
                            setFieldValue,
                            initialFormValues
                        )}
                        name={names.retention}
                        inputIsDisabled
                        minNumber="1"
                    />
                    <CustomSelect
                        placeholder={text.service_name}
                        onChange={(_, value) => {
                            handleChangeFormValue(
                                value,
                                names.service_id,
                                setFieldValue,
                                initialFormValues
                            )
                        }}
                        infoText={text.service_name_info}
                        value={values.service_id}
                        name={names.service_id}
                        isClearable
                        options={services}
                        error={errors?.service_id}
                    />
                    <Checkbox
                        checked={values.enabled}
                        type="checkbox"
                        label={text.enable}
                        name={names.enabled}
                        onChange={(e) => handleChangeFormValue(
                            e?.target?.checked,
                            names.enabled,
                            setFieldValue,
                            initialFormValues,
                            true
                        )}
                    />
                    <div className="submit-button-wrapper">
                        <SimpleBlueButton
                            type="submit"
                        >
                            {isButtonLoading && <ButtonLoader />}
                            {logGroupId ? text.update_log_group : text.submit}
                        </SimpleBlueButton>
                    </div>
                </form>
            )}
        </Formik>
    )
}

export default AddEditLogGroup
